/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/Toolbox/PseudoRandom',[],function () {

    function lower32(n) {
        return (((n >> 16) & 0xFFFF) << 16) | (n & 0xFFFF);
    };

    var PseudoRandom = function (seeds, carry, r, multiplier) {
        if (seeds != null && typeof seeds != 'array') {
            seeds = [seeds];
        }
        this.initPseudoRandom(seeds, carry, r, multiplier);
    };

    PseudoRandom.UInt32 = {
        MaxValue: 0xFFFFFFFF
    };

    PseudoRandom.prototype.initPseudoRandom = function (seeds, carry, r, multiplier) {
        carry = carry || +Date.now();
        r = r || 64;
        multiplier = multiplier || 987657110;

        this.NumSeeds = r;
        this.Multiplier = multiplier;
        this.N = 0;
        this.Seeds = new Array(r);
        seeds = seeds == null || seeds.length == 0 ? [(+Date.now())] : seeds;
        this.Carry = ((carry & 0xFFFFFFFF) >>> 0) % multiplier;

        for (var i = 0; i < r; ++i) {
            if (i < seeds.length) {
                this.Seeds[i] = (seeds[i] & 0xFFFFFFFF) >>> 0;
            }
            else
            {
                this.Seeds[i] = ((Math.random() * 0xFFFFFFFF) & 0xFFFFFFFF) >>> 0;
            }
            if (this.Seeds[i] == 0xFFFFFFFF)
            {
                this.Seeds[i] = 1;
            }
        }
    };

    PseudoRandom.prototype.GetNextRandomBytes = function (b) {
        // Return value
       var retVal = new Array(b);

        // Backup of state information: Only want to advance the PRNG
        // one step, not b steps!
        var nBkp = 0;
        var carryBkp = 0;
        var seedBkp = new Array(this.NumSeeds);

        retVal[b - 1] = this.GetNext32(PseudoRandom.UInt32.MaxValue);
        carryBkp = this.Carry;
        nBkp = this.N;


        seedBkp = this.Seeds.slice(0);

        for (var i = (b - 2); i >= 0; i--)
        {
            retVal[i] = this.GetNext32(PseudoRandom.UInt32.MaxValue);
        }

        this.Carry = carryBkp;
        this.N = nBkp;

        this.Seeds = seedBkp.slice(0);


        return retVal;
    };

    /// <summary>
    /// Get a random integer M, where 0 <= M <= maxValue
    /// </summary>
    /// <param name="maxValue">The upper bound for the number (inclusive).</param>
    /// <returns>A random integer M where 0 <= M <= maxValue.</returns>
    PseudoRandom.prototype.GetNext32 = function (maxValue)
    {
        var t = this.Multiplier * this.Seeds[this.N] + this.Carry;
        var div32 = t >>> 16;
        div32 = div32 >>> 16;
        this.Carry = div32 + (((t & 0xFFFFFFFF) >>> 0) >= 0xFFFFFFFF - div32 ? 1 : 0);
        this.Seeds[this.N] = 0xFFFFFFFE - ((t & 0xFFFFFFFF) >>> 0) - (this.Carry - div32 << 32) - ((this.Carry & 0xFFFFFFFF) >>> 0);
        var result = this.Seeds[this.N];
        this.N = (this.N + 1 & this.NumSeeds - 1) >>> 0;
        return result % maxValue;
    };

    return PseudoRandom;
});

